import s from './MenuToggle.scss';
import { DataHook } from '../../modules/dataHooks';

export interface MenuToggleProps {
  t(key: string): string;
}

export const MenuToggle = ({ t }: MenuToggleProps) => {
  return `
    <button
      class="${s.hamburger}"
      title="${t('open_navigation')}"
      aria-label="${t('open_navigation')}"
      data-toggle="collapse"
      aria-haspopup="true"
      data-expanded="false"
      aria-expanded="false"
      data-hook="${DataHook.HamburgerButton}"
    >
    <span class="${s.hamburgerBox}">
      <span class="${s.hamburgerInner}"></span>
    </span>
    </button>
  `;
};
